import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import { Refresh } from "@mui/icons-material";
import DivExist from "./DivExist";
import { Tooltip, CircularProgress } from "@mui/material";

/**
 *
 * @param {object} param0
 * @param {function} param0.onBtnClick
 * @param {boolean} param0.hide
 * @param {"large"|"medium"|"small"} param0.size
 * @param {boolean} param0.disabled
 * @param {'inherit'|'primary'|'secondary'|'success'|'error'|'info'|'warning'} param0.color
 * @param {string} param0.tooltip
 * @param {boolean} param0.withProcessing
 * @param {number} param0.progressTimeout
 * @returns
 */
export default function IconButtonRefresh({
  onBtnClick,
  hide,
  size = "large",
  disabled,
  color,
  tooltip,
  withProcessing,
  progressTimeout
}) {
  const [processing, setProcessing] = useState(false);
  const [timeoutSec, setTimeoutSec] = useState(null);
  useEffect(() => {
    if (timeoutSec !== null) {
      const timer = setInterval(() => {
        setTimeoutSec((prev) => {
          if (prev <= 1) {
            setProcessing(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }

  }, [timeoutSec, progressTimeout]);
  return (
    <DivExist show={!hide}>
      <DivExist show={!(withProcessing && processing)}>
        <Tooltip title={tooltip || ""}>
          <IconButton
            onClick={async () => {
              let t;
              setTimeoutSec(progressTimeout || 10);
              setProcessing(true);
              // if (withProcessing) {
              //   t = setTimeout(() => setProcessing(false), progressTimeout * 1000 || 10000);
              // }
              await onBtnClick();
              setProcessing(false);
              setTimeoutSec(null);
              // if (withProcessing) clearTimeout(t);
            }}
            size={size}
            disabled={disabled}
            color={color}
          >
            <Refresh fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </DivExist>
      {/* <DivExist show={withProcessing && processing && !progressTimeout}>
        <CircularProgress size={size === "large" ? 25 : size === "medium" ? 20 : 15} />
      </DivExist> */}
      <DivExist show={(timeoutSec > 0 && withProcessing) ? true : false}>
        <CircularProgress
          sx={{ margin: "10px" }}
          variant={progressTimeout ? "determinate" : "indeterminate"}
          value={timeoutSec / (progressTimeout || 10) * 100}
          size={size === "large" ? 25 : size === "medium" ? 20 : 15}
        />
      </DivExist>
    </DivExist>
  );
}
